import React from 'react';
import { Box, Typography } from '@mui/material';
import BaiglabsLogo from './BaiglabsLogo';

const WORDMARK = '"Manrope", "Segoe UI", system-ui, sans-serif';
const INK = '#0c1a2e';

/**
 * Professional BaigLabs lockup — mark + clean wordmark (no “bAI” split / glow).
 */
function BaiglabsCombinedLogo({
  size = 'medium',
  orientation = 'horizontal',
  showTagline = false,
  iconSize = null,
}) {
  const sizeMap = {
    small: {
      fontSize: '1.05rem',
      taglineFontSize: '0.65rem',
      iconSize: 28,
      spacing: 1,
    },
    medium: {
      fontSize: '1.35rem',
      taglineFontSize: '0.7rem',
      iconSize: 36,
      spacing: 1.25,
    },
    large: {
      fontSize: '1.85rem',
      taglineFontSize: '0.8rem',
      iconSize: 44,
      spacing: 1.5,
    },
    xlarge: {
      fontSize: '2.4rem',
      taglineFontSize: '0.9rem',
      iconSize: 56,
      spacing: 2,
    },
  };

  const currentSize = sizeMap[size] || sizeMap.medium;
  const finalIconSize = iconSize || currentSize.iconSize;

  const wordmark = (
    <Typography
      component="span"
      sx={{
        fontFamily: WORDMARK,
        fontWeight: 700,
        fontSize: currentSize.fontSize,
        letterSpacing: '-0.035em',
        color: INK,
        lineHeight: 1,
        whiteSpace: 'nowrap',
      }}
    >
      BaigLabs
    </Typography>
  );

  const tagline = showTagline ? (
    <Typography
      sx={{
        fontFamily: WORDMARK,
        fontSize: currentSize.taglineFontSize,
        fontWeight: 600,
        letterSpacing: '0.12em',
        textTransform: 'uppercase',
        color: 'rgba(12, 26, 46, 0.5)',
        lineHeight: 1,
        mt: 0.75,
      }}
    >
      Products & platforms
    </Typography>
  ) : null;

  if (orientation === 'vertical') {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <BaiglabsLogo size={finalIconSize} />
        <Box sx={{ mt: currentSize.spacing / 2, textAlign: 'center' }}>
          {wordmark}
          {tagline}
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: orientation === 'horizontal' ? 'flex-start' : 'center' }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: currentSize.spacing,
        }}
      >
        <BaiglabsLogo size={finalIconSize} />
        {wordmark}
      </Box>
      {tagline}
    </Box>
  );
}

export default BaiglabsCombinedLogo;
